import React, { useState, useRef, useEffect } from 'react'
import { ReactComponent as RightArrow } from '../../icon/right-arrow.svg'
import { ReactComponent as LeftArrow } from '../../icon/left-arrow.svg'
import Theme from '../../library/Theme'
import { PresetImage } from '../../library/Preset'

interface StickersToolbarProps {
  theme: Theme
  stickers: PresetImage[]
  handleSticker: (stickerImg: HTMLImageElement) => void
}

function StickersToolbar({ theme, stickers, handleSticker }: StickersToolbarProps) {
  const [showControls, setShowControls] = useState(true)
  const [enableLeftControl, setEnableLeftControl] = useState(false)
  const [enableRightControl, setEnableRightControl] = useState(false)
  const toolbarRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    updateControls()
  })

  const scroll = (x: number) => {
    let toolbar = toolbarRef.current
    if (!toolbar) {
      return
    }
    toolbar.scrollLeft += x
  }

  const updateControls = () => {
    let toolbar = toolbarRef.current
    if (!toolbar) {
      return
    }

    setEnableLeftControl(toolbar.scrollLeft > 0)
    setEnableRightControl(toolbar.scrollLeft + toolbar.clientWidth < toolbar.scrollWidth)
    setShowControls(toolbar.clientWidth < toolbar.scrollWidth)
  }

  const scrollAmount = toolbarRef.current ? toolbarRef.current.clientWidth / 2 : 100

  const drag = (e: React.DragEvent) => {
    e.dataTransfer.setData("sticker", (e.target as Element).id)
  }

  return (
    <div className="toolbarContainer">

      {showControls &&
        <div className={"controlButton" + (enableLeftControl ? "" : " disabled")} style={theme.buttonStyle} onClick={(x) => scroll(-scrollAmount)}>
          <LeftArrow style={theme.svgStyle} />
        </div>
      }
      <div ref={toolbarRef} className="toolbar" onScroll={updateControls}>
        {stickers.map((sticker, index) =>
          <img
            crossOrigin="anonymous"
            className="toolbarItem sticker"
            id={"sticker" + index}
            key={index}
            src={sticker.url}
            alt={"Sticker " + index}
            draggable="true"
            onDragStart={drag}
            onLoad={updateControls}
            onClick={
              (e: React.MouseEvent) => {
                let stickerCopy = (e.target as HTMLImageElement).cloneNode(true) as HTMLImageElement
                handleSticker(stickerCopy)
              }
            }
          />
        )}
      </div>

      {showControls &&
        <div className={"controlButton" + (enableRightControl ? "" : " disabled")} style={theme.buttonStyle} onClick={(x) => scroll(scrollAmount)}>
          <RightArrow style={theme.svgStyle} />
        </div>
      }
    </div>
  )
}

export default StickersToolbar
